import TrailCard from '@alltrails/cards/components/TrailCard';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import clickFromSection from '../../../utils/PageUI/clickFromSection';
import type { PageUITrailResultSection } from '../../../utils/PageUI/pageUI';
import trailFromPageUISection from '../../../utils/PageUI/trailFromPageUISection';
import { usePageUIActions } from '../PageUIActionContext/PageUIActionContext';
import { usePageUIMapHover } from '../PageUIMapHoverContext/PageUIMapHoverContext';
import styles from './PageUITrailResult.module.scss';

type Props = {
  /** The section's position in the PageUI result list */
  index: number;
  section: PageUITrailResultSection;
};

export default function PageUITrailResult({ index, section }: Props) {
  const languageRegionCode = useLanguageRegionCode();
  const { onSectionHover, onSectionHoverEnd } = usePageUIMapHover();
  const actions = usePageUIActions();
  const click = clickFromSection(section, index);

  return (
    <TrailCard
      blockNavigation={Boolean(actions)}
      className={styles.trailResult}
      languageRegionCode={languageRegionCode}
      onCardClick={actions && (event => actions.onClick(click, event))}
      onCardMouseEnter={() => onSectionHover(section)}
      onCardMouseLeave={onSectionHoverEnd}
      openInNewTab={!actions}
      trail={trailFromPageUISection(section)}
      url={actions?.getHref(click.clickAction)}
      variant="small"
    />
  );
}
